// extracted by mini-css-extract-plugin
export default {"video":"video_video__sExuw","box":"video_box__btATP","textneon":"video_textneon__PjYcM"};